
import React from 'react';
import { Link } from 'react-router-dom';
import { ShieldCheck, Lock, Eye, CheckCircle } from 'lucide-react';

const Privacy: React.FC = () => {
  return (
    <div className="min-h-screen relative">
      {/* Background Image with Blur */}
      <div 
        className="fixed inset-0 bg-fixed bg-cover bg-center z-0"
        style={{ backgroundImage: "url('https://images.unsplash.com/photo-1542314831-068cd1dbfeeb?ixlib=rb-4.0.3&auto=format&fit=crop&w=2000&q=80')" }}
      >
        <div className="absolute inset-0 bg-white/40 backdrop-blur-[10px]"></div>
      </div>

      <div className="relative z-10 py-20 px-4">
        <div className="max-w-4xl mx-auto bg-white/95 backdrop-blur-sm rounded-3xl p-10 shadow-xl border border-white/50">
            <h1 className="text-4xl font-bold text-navy mb-8 border-b border-gray-200 pb-4">Politique de Confidentialité</h1>

            <section className="mb-8">
                <h2 className="text-2xl font-bold text-navy mb-4">Document en cours de finalisation</h2>
                <p className="text-gray-700 text-lg leading-relaxed">
                   Notre politique de confidentialité complète est actuellement en cours de rédaction et sera disponible prochainement.
                </p>
            </section>

            <section className="mb-10">
                <h2 className="text-2xl font-bold text-navy mb-6">Notre engagement</h2>
                <p className="text-gray-700 mb-6">
                    Chez Le Démarcheur Facilitateur, nous prenons la protection de vos données personnelles très au sérieux.
                </p>

                <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-8">
                    <div className="bg-blue-50 p-6 rounded-2xl flex items-start">
                        <ShieldCheck className="text-blue-600 mr-3 flex-shrink-0" size={24} />
                        <div>
                            <h3 className="font-bold text-navy mb-1">Confidentialité</h3>
                            <p className="text-sm text-gray-600">Vos coordonnées ne sont jamais affichées publiquement.</p>
                        </div>
                    </div>
                    <div className="bg-green-50 p-6 rounded-2xl flex items-start">
                        <Lock className="text-green-600 mr-3 flex-shrink-0" size={24} />
                        <div>
                            <h3 className="font-bold text-navy mb-1">Sécurité</h3>
                            <p className="text-sm text-gray-600">Toutes les données sont stockées de manière sécurisée et chiffrées.</p>
                        </div>
                    </div>
                    <div className="bg-orange/10 p-6 rounded-2xl flex items-start">
                        <Eye className="text-orange mr-3 flex-shrink-0" size={24} />
                        <div>
                            <h3 className="font-bold text-navy mb-1">Transparence</h3>
                            <p className="text-sm text-gray-600">Seules nos équipes internes ont accès aux informations.</p>
                        </div>
                    </div>
                    <div className="bg-purple-50 p-6 rounded-2xl flex items-start">
                        <CheckCircle className="text-purple-600 mr-3 flex-shrink-0" size={24} />
                        <div>
                            <h3 className="font-bold text-navy mb-1">Contrôle</h3>
                            <p className="text-sm text-gray-600">Vous pouvez demander la modification ou suppression de vos données.</p>
                        </div>
                    </div>
                </div>
            </section>

            <section className="mb-10">
                <h2 className="text-2xl font-bold text-navy mb-4">Contact</h2>
                <div className="bg-gray-50 p-6 rounded-2xl border border-gray-100">
                    <p className="mb-2">Pour toute question concernant vos données personnelles :</p>
                    <p className="mb-2"><strong className="text-navy">Email :</strong> <a href="mailto:ledemarcheur@lefacilitateur.online" className="text-orange hover:underline">ledemarcheur@lefacilitateur.online</a></p>
                    <p><strong className="text-navy">Téléphone :</strong> +229 01 97 40 67 67</p>
                </div>
            </section>
            
            <hr className="border-gray-200 mb-8"/>

            <p className="text-gray-500 italic mb-8 text-sm">
                Notre politique de confidentialité détaillée sera publiée prochainement et contiendra toutes les informations légales requises concernant la collecte, l'utilisation et la protection de vos données.
            </p>

            <div className="text-center">
                <Link to="/" className="inline-block bg-orange text-white font-bold py-3 px-8 rounded-xl hover:bg-orange/90 transition shadow-lg">
                    Retour à l'accueil
                </Link>
            </div>
        </div>
      </div>
    </div>
  );
};

export default Privacy;
